// enforce North American phone number format
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan#Modern_plan
export const PHONE_NUMBER_REGEX = /^[2-9][0-9]{2}[2-9][0-9]{2}[0-9]{4}$/

export const unmaskPhoneNumber = (phoneNumber?: string): string | null => {
  if (!phoneNumber) {
    return null
  }
  let unmaskedPhone = phoneNumber.replace(/\D/g, '')
  while (unmaskedPhone.length > 10) {
    unmaskedPhone = unmaskedPhone.substring(1)
  }
  return unmaskedPhone
}

export const formatPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}

export const isValidUSPhoneNumber = (phoneNumber: string): boolean => {
  const unmaskedPhone = unmaskPhoneNumber(phoneNumber)
  if (!unmaskedPhone) {
    return false
  }

  return PHONE_NUMBER_REGEX.test(unmaskedPhone)
}
